module.exports = function (gsap, SplitText) {
    const header = document.querySelector('.main-header'),
        menuBtn = document.querySelector('.main-aside__btn-menu');

    document.querySelector('.main-aside__btn-letter').addEventListener("click", (item) => {
        item.target.classList.toggle('is-active');
        header.classList.toggle('is-menu-open');

        menuBtn.classList.toggle('is-hidden');

        if (item.target.classList.contains('is-active')) {
            tlPopup.timeScale(1).play();
        } else {
            gsap.timeline({
                    onComplete: () => {
                        tlPopup.timeScale(100).reverse();
                    }
                })
                .set('.main-header', {
                    backgroundColor: 'transparent',
                })
                .to('.popup-contact', {
                    opacity: 0,

                });

        }
    });

    let tlPopup = gsap.timeline({
            paused: true
        }),
        split = new SplitText(".popup-contact .popup-contact__title", {
            type: "words, chars"
        }),
        chars = split.chars;

    tlPopup
        .set('body', {
            overflow: 'hidden'
        })
        .to('.popup-contact', {
            display: 'block',
            xPercent: -100,
            opacity: 1,
            duration: 0.75,
        })
        .set('.main-header', {
            backgroundColor: '#fffa00',
        })
        .fromTo('.popup-contact .popup-contact__content > .heading-small', {
            xPercent: -100,
            opacity: 0
        }, {
            xPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)"
        })
        .from(chars, {
            duration: 0.25,
            opacity: 0,
            yPercent: 40,
            ease: "back.out(1.7)",
            stagger: 0.05
        })
        .fromTo('.popup-contact .popup-contact__links__link .heading-small', {
            xPercent: -100,
            opacity: 0
        }, {
            xPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)",
            stagger: 0.05
        })
        .fromTo('.popup-contact .popup-contact__links__link .btn', {
            xPercent: -100,
            opacity: 0
        }, {
            xPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)",
            stagger: 0.05
        }, '-=0.2')
        .fromTo('.popup-contact .popup-contact__form .heading-small', {
            xPercent: -100,
            opacity: 0
        }, {
            xPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)"
        }, '-=0')
        .fromTo('.popup-contact .popup-contact__form .form-group', {
            yPercent: 100,
            opacity: 0
        }, {
            yPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)",
            stagger: 0.05
        }, '-=0.5')
        .fromTo('.popup-contact .popup-contact__form .form-submit', {
            yPercent: 100,
            opacity: 0
        }, {
            yPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)",
        }, '-=0.5')

};